import React from 'react';
import { useSelector } from 'react-redux';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Alert from '@mui/material/Alert';

import config from 'config';
import { selectOrganization, selectUser } from 'entities/user/selectors';
import { usePayPalVerificationState } from 'containers/VerificationRoute';
import { useContent } from 'components/Flow/flows/nonprofitOnboardingPayment/components/useContent';
import { computeDonationProviderForNonprofit } from 'utils/computeDonationProviderForNonprofit';
import { UserState } from 'entities/user/reducer';
import { Privileges } from 'utils/privileges';

const StatusNotificationInner = ({ user }: { user: UserState }) => {
  const organization = useSelector(selectOrganization);
  const state = usePayPalVerificationState(user);

  const hasToEnroll = (state?.value as { paypal: string })?.paypal === 'enroll';

  const donationProvider =
    user?.organization &&
    computeDonationProviderForNonprofit(
      user?.organization,
      user?.organization?.settings?.get('preferStripe') || false
    );

  const content = useContent(
    donationProvider,
    user?.organization,
    user?.hasPrivilege(Privileges.ORGANIZATION_SELF_VERIFIED)
  );

  if (organization?.type !== 'Nonprofit') {
    return null;
  }

  const { verificationStatus } = organization;

  if (typeof verificationStatus === 'undefined' || verificationStatus === 'active') {
    return null;
  }

  return (
    <Alert
      icon={<AccessTimeIcon fontSize="inherit" />}
      severity="warning"
      style={{ marginBottom: '16px', height: 48 }}
    >
      Your nonprofit&rsquo;s verification status is now {verificationStatus}, and platform access is
      limited.{' '}
      {hasToEnroll ? (
        <>
          Please <a href={content.link}>enroll with PPGF</a> to become active again.
        </>
      ) : (
        <>
          Please email{' '}
          <a href={`mailto:${config.nonprofitSuccessTeamEmail}`}>Nonprofit Success Team</a> for
          assistance.
        </>
      )}
    </Alert>
  );
};

export const StatusNotification = () => {
  const user = useSelector(selectUser);

  if (!user) {
    return null;
  }

  return <StatusNotificationInner user={user} />;
};
